import { it } from './it';
import { en } from './en';

export const translations = {
  it,
  en,
};

export const defaultLanguage = 'it';
export const supportedLanguages = ['it', 'en'];
